export default __webpack_public_path__ + "static/bed-71280-292328451b69563bd24e4fcd61941660.png";